/**
 * Parses a user-typed amount that may use thousands-separator commas (Indian
 * or Western grouping — "1,20,2893.323" or "1,202,893.323"). Returns null
 * when what's left after stripping commas isn't a valid non-negative number,
 * so callers can surface a validation error instead of silently saving NaN/0.
 */
export function parseAmountInput(raw: string): number | null {
  const stripped = raw.trim().replace(/,/g, "");
  if (stripped === "" || !/^\d+(\.\d+)?$/.test(stripped)) return null;
  const value = Number(stripped);
  return Number.isFinite(value) ? value : null;
}
